import { CompassCardUI } from '@scale/compass-ui/types';
import {
  ModalExecutionCardShared,
  type ModalExecutionSchemaType,
  type ModalExecutionContext,
  MODAL_EXECUTION,
} from '@scale/genai-compass-shared/cards/modal_execution';
import ModalExecutionCardComponent from './ModalExecutionCardComponent';
import { faCircleNodes } from '@fortawesome/pro-solid-svg-icons';

const defaultContext: ModalExecutionContext = {
  cardType: MODAL_EXECUTION,
  modalAppName: '',
  modalFunctionName: '',
};

export const ModalExecutionCardInfo: CompassCardUI<ModalExecutionSchemaType> = {
  ...ModalExecutionCardShared,
  title: 'Modal Execution',
  icon: 'circle-nodes',
  toolTip: 'Execute data transformation via Modal function',
  defaultContext,
  ownerTeam: 'Connectivity',
  isAdvanced: true,
  legacyComponent: ModalExecutionCardComponent,
  button: {
    icon: faCircleNodes,
  },
};
